import React, { SetStateAction } from "react";
import { CameraVideo, Clipboard2Data, GeoAlt } from "react-bootstrap-icons";
import StepsTabs from "components/Messages/components/ReportContainer/StepsTabs";
import { useTranslation } from "react-i18next";
import { ReportInformationFirstStep } from "models/ReportInformationFirstStep";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import ReportTitle from "./Reportitle";
import ReportForm from "../ReportForm";

type ReportDetailsFormProps = {
  currStep: number;
  setCurrStep: React.Dispatch<SetStateAction<number>>;
  reportDetails?: ReportInformationFirstStep;
  handleClose?: () => void;
};

// This component renders in two screens:
// 1. in spesific report from screen "inProgress" or "inFollowup".
// 2. in messages screen.
const ReportDetailsForm = ({
  setCurrStep,
  currStep,
  handleClose,
  reportDetails,
}: ReportDetailsFormProps) => {
  const { t } = useTranslation();
  const locationString = useLocationForReportType();
  const isMessagesScreen = locationString === "followup-messages";

  return (
    <div className="reportContainer spaceTop">
      <h2 className="title borderBottom">
        <ReportTitle
          reportDetails={reportDetails}
          isMessagesExist={reportDetails?.isMessagesExist}
          handleClose={handleClose}
        />
      </h2>

      {isMessagesScreen && (
        <StepsTabs
          currStep={currStep}
          setCurrStep={setCurrStep}
          steps={[
            {
              index: 1,
              title: t("wizardStep1Title"),
              icon: <CameraVideo />,
            },
            {
              index: 2,
              title: t("wizardStep2Title"),
              icon: <GeoAlt />,
            },
            {
              index: 3,
              title: t("wizardStep3Title"),
              icon: <Clipboard2Data />,
            },
          ]}
        />
      )}

      <ReportForm
        reportDetails={reportDetails}
        currStep={currStep}
        setCurrStep={setCurrStep}
      />
    </div>
  );
};

export default ReportDetailsForm;
